import Script from 'next/script'

import axios from '@/utils/axiosInterceptor'

export default function Hubspot({}) {
    return (
        <Script
            id="hs-script-loader"
            src="//js-eu1.hs-scripts.com/145801917.js"
            async
            defer
            strategy="afterInteractive"
            onLoad={() => {
                function onConversationsAPIReady() {
                    const authenticateHubspotChat = async () => {
                        try {
                            const { data } = await axios.get('/assessment/api/auth/hubspotChatAuthentication')
                            if (data.success) {
                                window.hsConversationsSettings = {
                                    identificationEmail: data.email,
                                    identificationToken: data.token,
                                }
                            }
                            window?.HubSpotConversations?.widget?.load()
                        } catch (error) {
                            console.error('Error authenticating Hubspot chat:', error)
                            window?.HubSpotConversations?.widget?.load()
                        }
                    }

                    authenticateHubspotChat()
                }

                window.hsConversationsSettings = {
                    loadImmediately: false,
                    identificationEmail: '',
                    identificationToken: '',
                }
                /*
                 If external API methods are already available, use them.
                */
                if (window.HubSpotConversations) {
                    onConversationsAPIReady()
                } else {
                    /*
                      Otherwise, callbacks can be added to the hsConversationsOnReady on the window object.
                      These callbacks will be called once the external API has been initialized.
                    */
                    window.hsConversationsOnReady = [onConversationsAPIReady]
                }
            }}
        ></Script>
    )
}
